<template>

    <div :class="[address.length == 0 ? 'delivery_address_zero' : 'delivery_address']">
        <div v-if="showAddAddress" class="shop_modal-fade"></div>
        <Transition name="bottomOpen">
    <div v-if="showAddAddress" class="openModalBottom">
        <div class="modal-close-pc"> <span class="modal-close-pc-title">Добавить новый адрес</span> <svg @click="openAddress();" viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></div>
        <Address_add :isMobile="isMobile" :address="address" @updateAddress="updateAddress"/>
    </div>
</Transition>

        <div v-for="item in address" class="delivery_address_item" @click="selectAddress(item)">{{ item.address + ', '+ item.apart }}</div>
        <div class="hcard-noItem" v-if="address.length == 0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="currentColor" stroke-width="1.5"/><path d="M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z" stroke="currentColor" stroke-width="1.5"/></svg>
<b>Нет адресов</b><br>Добавьте новый адрес доставки</div>
        <div class="hcart-order_btn" @click="openAddress()">Новый адрес</div>
    </div>
    
    </template>

    <script>
        import Address_add from './Address_add.vue';
    export default {
       name: 'Address_list',
       components: { Address_add },
        data(){
        return {
            showAddAddress: false,
        }
       },
       mounted(){

       },
       methods: {
        openAddress(){
            if(this.showAddAddress == true){
                this.showAddAddress = false
            }else{
                this.showAddAddress = true
            }  
        },
        updateAddress(){
            this.openAddress()
            this.$emit('changeAddress', 'update')
        },
        selectAddress(item){
            this.openAddress()
            this.$emit('changeAddress', 'select', item)
        }
       },
       props: ['isMobile', 'address'],
       emits: ['changeAddress'],
    }
    </script>
    
    <style scoped>
    
    </style>